import { Drawer } from "antd";
import { observer } from "mobx-react-lite";
import AddBrandForm from "../forms/add-brand-form";

/* eslint-disable-next-line */
export interface AddBrandDialogProps {
  opened: boolean;
  onToggle: () => void;
}

export function AddBrandDialog(props: AddBrandDialogProps) {
  const {
    opened,
    onToggle,
  } = props;

  return (
    <Drawer
      title="Add brand"
      width={320}
      closable={true}
      onClose={onToggle}
      open={opened}
    >
      <AddBrandForm
        onSubmitted={onToggle}
      />
    </Drawer>
  );
}

export default observer(AddBrandDialog);
